import { create } from "zustand";
import { save, retrieve, remove } from "../helpers/StorageHelper";
import { AUTH_TOKEN } from "../constants/localStorageKeys";
import { zustandLogger } from "../Utils/logger";

// Hydrate initial auth state synchronously from localStorage to avoid redirect flicker
const initialToken = retrieve(AUTH_TOKEN);

const useAuthStore = create((set) => ({
  authSession: initialToken,
  authStateLoading: false,
  authSessionExists: !!initialToken,

  setAuthSession: (token) => {
    set({ authStateLoading: true });
    zustandLogger.info("Setting auth session", { tokenExists: !!token });
    if (token) {
      save(AUTH_TOKEN, token);
      set({
        authSession: token,
        authStateLoading: false,
        authSessionExists: true,
      });
      zustandLogger.info("Auth session set successfully", { token });
    } else {
      zustandLogger.warn("No token provided, clearing auth session");
      remove(AUTH_TOKEN);
      set({
        authSession: null,
        authStateLoading: false,
        authSessionExists: false,
      });
      zustandLogger.info("Auth session cleared");
    }
  },

  clearAuthSession: () => {
    set({ authStateLoading: true });
    zustandLogger.info("Clearing auth session");
    remove(AUTH_TOKEN);
    set({
      authSession: null,
      authStateLoading: false,
      authSessionExists: false,
    });
    zustandLogger.info("Auth session cleared");
  },

  checkAuthSessionExists: () => {
    set({ authStateLoading: true });
    zustandLogger.info("Checking if auth session exists");
    const token = retrieve(AUTH_TOKEN);

    if (token) {
      set({
        authSession: token,
        authStateLoading: false,
        authSessionExists: true,
      });
      zustandLogger.info("Auth session exists", { token });
    } else {
      zustandLogger.warn("No auth session found");
      set({
        authStateLoading: false,
        authSession: null,
        authSessionExists: false,
      });
    }
  },
}));

export default useAuthStore;
